GameObject = require './gameObject'
keys = require 'keys'

class Dude extends GameObject
  constructor: (x, y, gridHelper, scrWidth, scrHeight) ->
    super x, y, gridHelper

    @moveSpeed = 5

    @controls =
      up    : false
      down  : false
      left  : false
      right : false

    @images = @createImages [
      "dude.png",
      "dude2.png",
      "dude2left.png",
      "dudeleft.png",
      "dude2_noG.png",
      "dude2left_noG.png",
      "dude_noG.png",
      "dudeleft_noG.png"
    ]

    @drawable = @images[0]
    @drawable.x = scrWidth >> 1
    @drawable.y = scrHeight >> 1

    document.onkeydown = (e) => @onKey e, true
    document.onkeyup   = (e) => @onKey e, false

  update: =>
    if @controls.right
      @x += @moveSpeed
    if @controls.left
      @x -= @moveSpeed
    if @controls.up
      @y -= @moveSpeed
    if @controls.down
      @y += @moveSpeed

  onKey: (e, bool) =>
    switch e.which
      when keys.LEFT, keys.A
        @controls.left = bool
      when keys.RIGHT, keys.D
        @controls.right = bool
      when keys.W, keys.UP
        @controls.up = bool
      when keys.S, keys.DOWN
        @controls.down = bool


module.exports = Dude
